'use strict';

var implementation = require('./implementation');

module.exports = Function.prototype.bind || implementation;



//////////////////
// WEBPACK FOOTER
// ./~/get-intrinsic/~/function-bind/index.js
// module id = 956
// module chunks = 259